import styled from 'styled-components'
import COLORS from '@colors'

export const Primary = styled.button`
  width: ${props => (props.block ? '100%' : 'fit-content')};
  border: 0;
  border-radius: 4px;
  background-color: ${COLORS.leather};
  color: ${COLORS.white};
  padding: 10px 25px;
  cursor: pointer;
  outline: 0;

  :disabled {
    background-color: rgba(0, 0, 0, 0.2);
  }
`

export const Secondary = styled.button`
  width: ${props => (props.block ? '100%' : 'fit-content')};
  border: 1px solid ${COLORS.leather};
  border-radius: 4px;
  background-color: ${COLORS.white};
  color: ${COLORS.leather};
  padding: 10px 25px;
  cursor: pointer;
  outline: 0;

  :disabled {
    background-color: rgba(0, 0, 0, 0.2);
  }
`
